import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import axios from "axios";
import { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";

export default function JdResumeAnalysis({ title, link }) {
  const [file, setFile] = useState(null);
  const [trainload, setTrainload] = useState(false);
  const [compareLoad, setCompareLoad] = useState(false);
  const [deleteError, setdeleteError] = useState("");
  const [file1, setFile1] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [pdfdone, setPdfDone] = useState(false);
  const [pdfdone1, setPdfDone1] = useState(false);
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [userquery, setUserQuery] = useState("");
  const [selectLanguageDisplay, setSelectLanguageDisplay] = useState("en");
  const [answerload, setAnswerload] = useState(false);
  const [trainError, setTrainError] = useState("");
  const [queryError, setQueryError] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);
  const [uploadStatus1, setUploadStatus1] = useState(false);
  const [isPdfUploading, setIsPdfUploading] = useState(false);
  const [isPdfUploading1, setIsPdfUploading1] = useState(false);
  const [selectedModel, setSelectedModel] = useState(
    "Compare the candidate's resume with the provided job description (JD). Identify and summarize the gaps in the candidate’s skills and experience relative to the JD. Focus on missing or underrepresented skills, qualifications, certifications, and relevant work experience.",
  );
  const [modeltext, setModelText] = useState("Resume gap analysis");
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const handleFileChange1 = (event) => {
    setFile1(event.target.files[0]);
  };
  const [transcript, setTranScript] = useState("");
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (transcript && transcript.length > 0) {
      const trimmedTranscript = formatResponse(transcript.trim());
      setDisplayText(""); // Clear the display text before starting
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + trimmedTranscript[index]);
        index++;
        if (index === trimmedTranscript.length) {
          clearInterval(intervalId); // Stop the interval once all characters are added
        }
      }, 1); // Adjusted delay for better rendering performance

      // Cleanup the interval when the effect is re-triggered
      return () => clearInterval(intervalId);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Splitting and replacing bold markers
    let responseArray = response.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    if (!userdata) return;
    var jsondata = JSON.parse(userdata);
    let emailAttr = jsondata["UserAttributes"].find(
      (attr) => attr["Name"] === "email",
    );
    let email = emailAttr ? emailAttr["Value"] : "";
    email.includes("genai2244") ? setgenaiaccess(true) : setgenaiaccess(false);
  }, []);

  const handleUpload = async () => {
    if (!file) return;
    setIsPdfUploading(true);
    setError("");
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    try {
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(file, username);
      setIsPdfUploading(false);
      setPdfDone(true);
      setUploadStatus(true);
      setError("File 1 uploaded successfully.");
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setIsPdfUploading(false);
    }
  };

  const handleUpload1 = async () => {
    if (!file1) return;
    setIsPdfUploading1(true);
    setError("");
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    try {
      await uploadFileViaPresignedUrl(file1, username);
      setIsPdfUploading1(false);
      setPdfDone1(true);
      setUploadStatus1(true);
      setError("File 2 uploaded successfully.");
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setIsPdfUploading1(false);
      setPdfDone1(false);
    }
  };

  const handleTrain = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    if ((file && pdfdone && file1, pdfdone1)) {
      setError("");
      setTrainload(true);
      setdeleteError("");
      console.log("training started");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        docname1: file.name,
        docname2: file1.name,
      });
      // var promptdata = JSON.stringify({
      //   docpath: username,
      //   docname: file1.name,
      // });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch requests
      const requesttrain = fetch(
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/finance-comparison",
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/jd-resume-gap-analysis",
        trainoption,
      );
      // const requestprompt = fetch(
      //   "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/prompt-engineered-training",
      //   promptoption
      // );

      Promise.all([requesttrain])
        .then(async ([trainresponse]) => {
          if (!trainresponse.ok) {
            setError("Training Failed!");
            setTrainload(false);
            throw new Error("One or both requests failed");
          }
          const data1 = await trainresponse.json();
          // const data2 = await promptresponse.json();

          // Handle the data from both responses
          console.log("Response from endpoint 1:", data1);
          // console.log("Response from endpoint 2:", data2);
          if (trainresponse.ok) {
            setError("Training completed.");
            setTrainload(false);
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the requests
          console.error("Error:", error);
          setError("Training Failed!");
          setTrainload(false);
        });
    } else {
      Swal.fire({
        html: "<p>Please upload the PDF's.</p>",
      });
    }
  };

  const handleCompare = async () => {
    //add filename passing parameter in post request and run post request of chatbot

    try {
      setCompareLoad(true); // Start the loading state
      // Add filename passing parameter in POST request and run POST request of chatbot
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        userPrompt: selectedModel,
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch request
      const requesttrain = await fetch(
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/jd-resume-gap-analaysis-response",
        trainoption,
      );

      // Parse the JSON data from the response
      const response = await requesttrain.json();
      setTranScript(response.message);
      // Log the data
      console.log("Response data:", response);
    } catch (error) {
      // Handle any errors
      console.error("There was an error with the fetch request:", error);
    } finally {
      setCompareLoad(false); // End the loading state
    }
  };

  const handleButtonClick = () => {
    if (file && file1) {
      handleTrain();
    } else {
      setError("Please upload both pdf files");
    }
  };

  const handleGenerateAnswer = () => {
    if (!file || !file1) {
      setError1("Please upload both files");
      return;
    }
    setError1("");
    handleCompare();
  };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="main-background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          alt="background-img"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {genaiaccess ? (
        <div
          style={{
            flex: "0.3",
            marginBottom: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            width: "80vw",
            gap: "3rem",
            margin: "auto",
          }}
          className="input-form-chatbot"
        >
          <div className="section-container">
            <h4>
              <strong>File upload window</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            <div>
              <p>Upload a Resume file:</p>
              <div className="field">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    accept=".pdf"
                    id="pdf-upload"
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="pdf-upload">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ width: "130px", marginRight: "1rem" }}
                    >
                      Select PDF
                    </Button>
                  </label>

                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    disabled={!file}
                    onClick={handleUpload}
                    style={{
                      marginBottom: "0.5rem",
                    }}
                    startIcon={
                      isPdfUploading && (
                        <CircularProgress color="white" size={20} />
                      )
                    }
                  >
                    Upload PDF
                  </Button>
                  {uploadStatus && (
                    <FaCheckCircle
                      style={{
                        marginLeft: "1rem",
                        color: "green",
                      }}
                      size={25}
                    />
                  )}
                </div>
                <Typography variant="body1">
                  <p style={{ wordBreak: "break-all", width: "350px" }}>
                    {file && `Selected file: ${file.name}`}
                  </p>
                </Typography>
              </div>

              <div className="field">
                <p>Upload a Job Description file:</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    accept=".pdf"
                    id="pdf-upload1"
                    type="file"
                    onChange={handleFileChange1}
                    style={{ display: "none" }}
                  />
                  <label
                    htmlFor="pdf-upload1"
                    style={{ pointerEvents: pdfdone ? "auto" : "none" }}
                  >
                    <Button
                      variant="contained"
                      component="span"
                      style={{
                        width: "130px",
                        marginRight: "1rem",
                      }}
                    >
                      Select PDF
                    </Button>
                  </label>

                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    disabled={!file1}
                    onClick={handleUpload1}
                    style={{
                      marginBottom: "0.5rem",
                    }}
                    startIcon={
                      isPdfUploading1 && (
                        <CircularProgress color="white" size={20} />
                      )
                    }
                  >
                    Upload PDF
                  </Button>
                  {uploadStatus1 && (
                    <FaCheckCircle
                      style={{
                        marginLeft: "1rem",
                        color: "green",
                      }}
                      size={25}
                    />
                  )}
                </div>
                <Typography variant="body1">
                  <p style={{ wordBreak: "break-all", width: "350px" }}>
                    {file1 && `Selected file: ${file1.name}`}
                  </p>
                </Typography>
              </div>

              <div style={{ display: "flex" }}>
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ color: "white" }}
                  onClick={handleButtonClick}
                  startIcon={
                    trainload && <CircularProgress color="white" size={20} />
                  }
                >
                  Train
                </Button>
              </div>

              <p>{error}</p>
            </div>
          </div>
          <div className="section-container">
            <h4>
              <strong>Output type</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <FormControl>
                <RadioGroup
                  style={{ width: "18rem" }}
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={selectedModel}
                  onChange={(e) => {
                    if (
                      e.target.value ===
                      "Compare the candidate's resume with the provided job description (JD). Identify and summarize the gaps in the candidate’s skills and experience relative to the JD. Focus on missing or underrepresented skills, qualifications, certifications, and relevant work experience."
                    ) {
                      setModelText("Resume gap analysis");
                    } else if (
                      e.target.value ===
                      "Given the job description (JD) and the candidate's resume, generate a list of relevant interview questions based on the gaps, strengths, and areas of interest highlighted in the resume. Focus on questions that assess the candidate's skills, experience, and qualifications related to the JD."
                    ) {
                      setModelText("Interview Question Generation");
                    }
                    setSelectedModel(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="Compare the candidate's resume with the provided job description (JD). Identify and summarize the gaps in the candidate’s skills and experience relative to the JD. Focus on missing or underrepresented skills, qualifications, certifications, and relevant work experience."
                    control={<Radio />}
                    label="Resume gap analysis"
                  />
                  <FormControlLabel
                    value="Given the job description (JD) and the candidate's resume, generate a list of relevant interview questions based on the gaps, strengths, and areas of interest highlighted in the resume. Focus on questions that assess the candidate's skills, experience, and qualifications related to the JD."
                    control={<Radio />}
                    label="Interview Question Generation"
                  />
                </RadioGroup>
              </FormControl>

              <Button
                style={{
                  marginTop: "1rem",
                  padding: "1.5rem 2rem",
                  width: "250px",
                }}
                variant="contained"
                color="primary"
                onClick={handleGenerateAnswer}
                startIcon={
                  compareLoad && <CircularProgress color="white" size={20} />
                }
              >
                Generate Answer
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
      <div
        className="input-form-chatbot"
        style={{
          flex: "0.3",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          width: "80vw",
          margin: "2rem auto",
        }}
      >
        <br />
        <br />
        <div className="section-container">
          <h4>
            <strong>Generated Response</strong>
          </h4>
          <hr style={{ background: "white" }}></hr>

          {displayText.length > 0 ? (
            <div
              style={{
                color: "white",
                fontFamily: "sans-serif",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
              dangerouslySetInnerHTML={{ __html: displayText }}
            ></div>
          ) : (
            "Response will be displayed here"
          )}
        </div>
      </div>
    </div>
  );
}
